export var API;
(function (API) {
    API.JSON_HEADER = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    API.constructDomain = function () {
        return location.protocol + '//' + location.host + '/';
    };
})(API || (API = {}));
